// extracted by mini-css-extract-plugin
export default {"container":"Awards_container__FvBt-"};